import script from "./ParticipantesAtividade.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticipantesAtividade.vue?vue&type=script&setup=true&lang=js"

import "./ParticipantesAtividade.vue?vue&type=style&index=0&id=0c0b9b6f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c0b9b6f"]])

export default __exports__